/* schneller-fahren.com · Theme JS v3 (light) */
(function () {
  'use strict';

  /* ── TOAST ───────────────────────── */
  function showToast(msg, icon) {
    var t = document.getElementById('sf-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'sf-toast';
      t.className = 'sf-toast';
      t.innerHTML = '<div class="toast-dot" id="toast-icon"></div><span id="toast-msg"></span>';
      document.body.appendChild(t);
    }
    document.getElementById('toast-icon').textContent = icon || '\u2713';
    document.getElementById('toast-msg').textContent = msg;
    t.classList.add('show');
    clearTimeout(t._t);
    t._t = setTimeout(function () { t.classList.remove('show'); }, 3000);
  }
  window.showToast = showToast;

  /* ── ADD TO CART (Legacy-Produktgrid) ── */
  window.addToCart = function (btn, variantId, qty) {
    if (!variantId) { showToast('Produkt nicht verf\u00FCgbar', '\u26A0\uFE0F'); return; }
    var origHTML = btn ? btn.innerHTML : '';
    if (btn) { btn.innerHTML = '<span class="btn-spinner"></span>'; btn.disabled = true; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Fehler'); });
      showToast('Im Warenkorb!', '\u2713');
      if (btn) btn.innerHTML = '\u2713 Hinzugef\u00FCgt';
      setTimeout(function () { window.location.href = '/cart'; }, 650);
    }).catch(function (err) {
      showToast(err.message || 'Fehler beim Hinzuf\u00FCgen', '\u26A0\uFE0F');
      if (btn) { btn.innerHTML = origHTML; btn.disabled = false; }
    });
  };

  /* ── PRODUKT-FILTER (Legacy-Grid) ── */
  window.filterProducts = function (btn, cat) {
    document.querySelectorAll('.filter-btn').forEach(function (b) { b.classList.remove('active'); });
    btn.classList.add('active');
    document.querySelectorAll('.product-card[data-cat]').forEach(function (c) {
      c.style.display = (cat === 'all' || c.dataset.cat === cat) ? '' : 'none';
    });
  };

  /* ── FAQ-AKKORDEON (Legacy-Section) ── */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('.faq-q');
    if (!q) return;
    var item = q.closest('.faq-item');
    if (!item) return;
    var isOpen = item.classList.contains('open');
    document.querySelectorAll('.faq-item.open').forEach(function (i) { i.classList.remove('open'); });
    if (!isOpen) item.classList.add('open');
  });

  /* ── SCROLL-REVEAL ───────────────── */
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -32px 0px' });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* ── COUNTDOWN (CTA-Banner) ──────── */
  function initCountdown() {
    var h = document.getElementById('cd-h');
    var m = document.getElementById('cd-m');
    var s = document.getElementById('cd-s');
    if (!h) return;
    var KEY = 'sf_offer_exp';
    var exp = 0;
    try { exp = parseInt(localStorage.getItem(KEY) || '0', 10); } catch (e) {}
    var now = Date.now();
    if (!exp || exp < now) {
      exp = now + 3 * 3600 * 1000;
      try { localStorage.setItem(KEY, String(exp)); } catch (e) {}
    }
    var tick = function () {
      var d = Math.max(0, Math.floor((exp - Date.now()) / 1000));
      h.textContent = String(Math.floor(d / 3600)).padStart(2, '0');
      m.textContent = String(Math.floor((d % 3600) / 60)).padStart(2, '0');
      s.textContent = String(d % 60).padStart(2, '0');
    };
    tick(); setInterval(tick, 1000);
  }

  /* ── INIT ────────────────────────── */
  function init() { initReveal(); initCountdown(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }

})();
